<script lang="ts" setup>
defineProps<{
  iconName: string
  isDisabled: boolean
  isOnWhiteBackground: boolean
}>()
</script>

<template>
  <div
    class="flex size-10 items-center justify-center rounded-full bg-white text-[24px] text-main-dark hover:text-main-green"
    :class="{
      'pointer-events-none text-main-gray': isDisabled,
      'cursor-pointer': !isDisabled,
      '!bg-main-very-light-gray': isOnWhiteBackground
    }"
  >
    <SvgIcon :name="iconName" />
  </div>
</template>
